import React from 'react';
import { useLabelStyles } from 'components/UI/V2/Forms/Label/Label.styles';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';

export interface LabelProps extends React.ComponentProps<'label'> {
    error?: string | null;
    required?: boolean;
}

export const Label: React.FC<LabelProps> = props => {
    const classes = useLabelStyles();

    return (
        <label
            className={clsx(classes.root, {
                [classes.hasError]: props.error
            })}
        >
            {props.error ? props.error : props.children}
            {props.required && <span className={classes.required}>*</span>}
        </label>
    );
};
